// PLUGINS IMPORTS //
import React from "react"
import styled from "styled-components"

// COMPONENTS IMPORTS //
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //
import { ListItemType } from "../../Data"

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  list: Array<ListItemType>
}

const BlockItem: React.FC<PropsType> = (props) => {
  return (
    <Wrapper>
      {props.list.map((item) => (
        <ItemWrap>
          <ItemTitle>{item.title}</ItemTitle> - {item.desc}
        </ItemWrap>
      ))}
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

const ItemWrap = styled.li`
  margin-bottom: 6px;
  margin-left: -15px;
  letter-spacing: 0.3px;
`

const ItemTitle = styled.span`
  font-weight: bold;
`

export default React.memo(BlockItem, memoComparison)
